import React, { useState, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
// import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports'; // Import Amplify config
import UserDashboard from './routes/UserDashboard';
import ZoneSelector from './routes/ZoneSelector';
import StyleSelector from './routes/StyleSelector';
import SunlightSelector from './routes/SunlightSelector';
import HouseEditor from './routes/HouseEditor';
import GardenBedEditor from './routes/GardenBedEditor';
import ChoosePlants from './routes/ChoosePlants';
import SummaryOne from './routes/SummaryOne';
import SummaryTwo from './routes/SummaryTwo';
import PrintableSummary from './routes/PrintableSummary';
import LoginCallback from './routes/LoginCallback';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './main.css';
import './App.css';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { SpreadsheetProvider } from './context/SpreadsheetContext';
import { ToastContainer } from 'react-toastify';
import { authenticateUser } from './api/backendApi';
import UrlStateManager from './components/UrlStateManager';
// import AuthWrapper from './auth/AuthWrapper';
import 'react-toastify/dist/ReactToastify.css';
import { ensureSession } from './auth/auth';
import { v4 as uuidv4 } from 'uuid';

import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';


// Amplify.configure(awsConfig);

function App() {
	// const { state, dispatch } = useContext(AppContext);

	const NotFound = () => <h1>Page Not Found</h1>;

	useEffect(() => {
		ensureSession();
	}, []);

	// useEffect(() => {
	// 	const sessionToken = localStorage.getItem('sessionToken');
	// 	console.log('Session token in front end:', sessionToken);

	// 	if (!sessionToken) {
	// 		console.error('No session token found.');
	// 		// window.location.href = 'https://www.mylandscapedesign.com';
	// 		return;
	// 	}

	// 	authenticateUser(sessionToken).then((response) => {
	// 		if (
	// 			(response && response.message === 'User authenticated successfully') ||
	// 			userId === 'adminUser'
	// 		) {
	// 			console.log('User authenticated:', response);
	// 		} else {
	// 			console.error('Error authenticating user:', response);
	// 			// window.location.href = 'https://www.mylandscapedesign.com/plans-pricing';
	// 		}
	// 	});
	// }, []);

	return (
		<MantineProvider>
			<AppProvider>
				<SpreadsheetProvider>
					<Router>
            <UrlStateManager />
            <Routes>
              <Route path='/' element={<UserDashboard />} />
              <Route path='/zone' element={<ZoneSelector />} />
              <Route path='/house-editor' element={<HouseEditor />} />
              <Route path='/style' element={<StyleSelector />} />
              <Route path='/sunlight' element={<SunlightSelector />} />
              <Route path='/garden-bed' element={<GardenBedEditor />} />
              <Route path='/choose-plants' element={<ChoosePlants />} />
              <Route path='/summary-one' element={<SummaryOne />} />
              <Route path='/summary-two' element={<SummaryTwo />} />
              <Route path='/printable-summary' element={<PrintableSummary />} />
              <Route path='/login-callback' element={<LoginCallback />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
            <ToastContainer position='top-right' autoClose={5000} hideProgressBar={false} />
          </Router>
        </SpreadsheetProvider>
      </AppProvider>
		</MantineProvider>
		// <AppProvider>
		// 	<SpreadsheetProvider>
		// 		<AuthProvider>
		// 			<Router>
		// 				<Routes>
		// 					<Route
		// 						path='/'
		// 						element={
		// 							<ProtectedRoute>
		// 								<UserDashboard />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/zone'
		// 						element={
		// 							<ProtectedRoute>
		// 								<ZoneSelector />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/style'
		// 						element={
		// 							<ProtectedRoute>
		// 								<StyleSelector />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/sunlight'
		// 						element={
		// 							<ProtectedRoute>
		// 								<SunlightSelector />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/house-editor'
		// 						element={
		// 							<ProtectedRoute>
		// 								<HouseEditor />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/garden-bed'
		// 						element={
		// 							<ProtectedRoute>
		// 								<GardenBedEditor />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/choose-plants'
		// 						element={
		// 							<ProtectedRoute>
		// 								<ChoosePlants />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/summary-one'
		// 						element={
		// 							<ProtectedRoute>
		// 								<SummaryOne />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 					<Route
		// 						path='/summary-two'
		// 						element={
		// 							<ProtectedRoute>
		// 								<SummaryTwo />
		// 							</ProtectedRoute>
		// 						}
		// 					/>
		// 				</Routes>
		// 				<ToastContainer
		// 					position='top-right'
		// 					autoClose={5000}
		// 					hideProgressBar={false}
		// 				/>
		// 			</Router>
		// 		</AuthProvider>
		// 	</SpreadsheetProvider>
		// </AppProvider>
	);
}

export default App;
